import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { CurecallButton, ECurecallButtonAppearance, ECurecallSize } from '@honestica/curecall-ui'
import { ECampaignType } from 'src/types/hr'
import { twMerge } from 'src/utils/tw-merge.util'

type TCampaignTypeCardProps = Readonly<{
  label: string
  description: string
  selected: boolean
  onClick: () => void
}>

const CampaignTypeCard = ({ label, description, selected, onClick }: TCampaignTypeCardProps) => (
  <button
    type="button"
    onClick={onClick}
    className={twMerge(
      'c-border-2 c-rounded-lg c-p-4 c-text-left c-transition-all c-cursor-pointer c-w-full',
      selected
        ? 'c-border-primary c-bg-primary-100'
        : 'c-border-grey-200 c-bg-white hover:c-border-primary-200',
    )}
  >
    <p className="c-font-semibold c-font-nexa c-text-sm c-mb-1">{label}</p>
    <p className="c-text-xs c-text-grey-500">{description}</p>
  </button>
)

type TProps = Readonly<{
  initialType: ECampaignType
  onNext: (type: ECampaignType) => void
  onCancel: () => void
}>

export const StepTypeSelection = ({ initialType, onNext, onCancel }: TProps) => {
  const { t } = useTranslation()
  const [selectedType, setSelectedType] = useState<ECampaignType>(initialType)

  return (
    <div className="c-flex c-flex-col c-gap-6 c-max-w-2xl c-mx-auto c-w-full">
      <div>
        <p className="c-font-semibold c-mb-3 c-text-sm">{t('pages.hr.campaigns.new.choose-type')}</p>
        <div className="c-flex c-gap-4">
          <CampaignTypeCard
            label={t('pages.hr.campaigns.new.alert-label')}
            description={t('pages.hr.campaigns.new.alert-description')}
            selected={selectedType === ECampaignType.ALERT}
            onClick={() => setSelectedType(ECampaignType.ALERT)}
          />
          <CampaignTypeCard
            label={t('pages.hr.campaigns.new.plan-blanc-label')}
            description={t('pages.hr.campaigns.new.plan-blanc-description')}
            selected={selectedType === ECampaignType.PLAN_BLANC}
            onClick={() => setSelectedType(ECampaignType.PLAN_BLANC)}
          />
        </div>
      </div>

      <div className="c-flex c-justify-between">
        <CurecallButton
          type="button"
          appearance={ECurecallButtonAppearance['PRIMARY-OUTLINED']}
          size={ECurecallSize.MEDIUM}
          onClick={onCancel}
        >
          {t('pages.hr.campaigns.new.cancel')}
        </CurecallButton>
        <CurecallButton
          type="button"
          appearance={ECurecallButtonAppearance.PRIMARY}
          size={ECurecallSize.MEDIUM}
          onClick={() => onNext(selectedType)}
        >
          {t('pages.hr.campaigns.new.contacts.next')}
        </CurecallButton>
      </div>
    </div>
  )
}
